import { Icon } from '@iconify/react';

const BillingTypesModal = ({
    show,
    handleClose,
    handleSubmit,
    formData,
    setFormData,
    editId,
    categories,
    frequencyMap,
    loading
}) => {
    if (!show) return null;

    return (
        <div className="modal-backdrop-custom" onClick={handleClose}>
            <div className="modal-content-custom card radius-16 border-0 shadow-lg" onClick={(e) => e.stopPropagation()}>
                <div className="card-header py-10 px-16 border-bottom d-flex align-items-center justify-content-between">
                    <h6 className="fw-semibold mb-0">{editId ? 'Edit' : 'Add New'} Billing Type</h6>
                    <button
                        onClick={handleClose}
                        className="btn btn-link p-0 text-secondary-light"
                    >
                        <Icon icon="mdi:close" className="text-xl" />
                    </button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="card-body p-24">
                        <div className="row gy-3">
                            <div className="col-12">
                                <label className="form-label text-secondary-light text-sm fw-medium mb-1">
                                    Title <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control radius-8 h-48-px"
                                    value={formData.invoice_title}
                                    onChange={(e) => setFormData({ ...formData, invoice_title: e.target.value })}
                                    placeholder="e.g., Monthly Maintenance"
                                    required
                                />
                            </div>
                            <div className="col-6">
                                <label className="form-label text-secondary-light text-sm fw-medium mb-1">
                                    Category <span className="text-danger">*</span>
                                </label>
                                <select
                                    className="form-select radius-8 h-48-px"
                                    value={formData.invoice_type}
                                    onChange={(e) => {
                                        const type = e.target.value;
                                        // QUICK has no frequency (one-time); leaving QUICK restores monthly.
                                        const frequency = type === 'QUICK' ? '-1'
                                            : (formData.invoice_type === 'QUICK' ? '1' : formData.frequency);
                                        setFormData({ ...formData, invoice_type: type, frequency });
                                    }}
                                    required
                                >
                                    {categories.map(cat => (
                                        <option key={cat} value={cat}>{cat}</option>
                                    ))}
                                </select>
                            </div>
                            {formData.invoice_type !== 'QUICK' && (
                            <div className="col-6">
                                <label className="form-label text-secondary-light text-sm fw-medium mb-1">
                                    Frequency <span className="text-danger">*</span>
                                </label>
                                <select
                                    className="form-select radius-8 h-48-px"
                                    value={formData.frequency}
                                    onChange={(e) => setFormData({ ...formData, frequency: e.target.value })}
                                    required
                                >
                                    {Object.entries(frequencyMap).map(([value, label]) => (
                                        <option key={value} value={value}>{label}</option>
                                    ))}
                                </select>
                            </div>
                            )}
                            {formData.invoice_type === 'QUICK' && (
                                <div className="col-6 d-flex align-items-end">
                                    <small className="text-secondary-light mb-8">
                                        Quick bills are raised as needed - no billing frequency required.
                                    </small>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="card-footer py-10 px-16 border-top d-flex justify-content-end gap-2">
                        <button
                            type="button"
                            onClick={handleClose}
                            className="btn btn-outline-secondary px-20 py-10 radius-8"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="btn px-20 py-10 radius-8 text-white"
                            style={{ backgroundColor: '#f59e0b' }}
                            disabled={loading}
                        >
                            {loading ? (
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            ) : (
                                <Icon icon={editId ? "mdi:check" : "mdi:plus"} className="text-lg me-1" />
                            )}
                            {editId ? 'Update' : 'Add'} Billing Type
                        </button>
                    </div>
                </form>
            </div>

            <style>{`
                .modal-backdrop-custom {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(0, 0, 0, 0.5);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 1050;
                    animation: fadeIn 0.2s ease;
                }

                .modal-content-custom {
                    width: 100%;
                    max-width: 500px;
                    margin: 16px;
                    animation: slideUp 0.3s ease;
                }

                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }

                @keyframes slideUp {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                /* Compact input height for BillingTypes modal (was 48px). */
                .h-48-px { height: 34px; font-size: 12px; padding-top: 4px; padding-bottom: 4px; }
            `}</style>
        </div>
    );
};

export default BillingTypesModal;
